import { z } from 'zod';

export const UserRole = z.enum(['MASTER', 'MANAGER', 'MEMBER', 'VIEWER']);
export type UserRole = z.infer<typeof UserRole>;

export const UserStatus = z.enum(['active', 'suspended', 'invited']);
export type UserStatus = z.infer<typeof UserStatus>;

export const ProjectRole = z.enum(['manager', 'member', 'viewer']);
export type ProjectRole = z.infer<typeof ProjectRole>;

export const ProjectStatus = z.enum(['active', 'archived']);
export type ProjectStatus = z.infer<typeof ProjectStatus>;

export const ScanStatus = z.enum(['pending', 'clean', 'infected', 'failed']);
export type ScanStatus = z.infer<typeof ScanStatus>;

export const Platform = z.enum(['ios', 'android', 'macos', 'windows']);
export type Platform = z.infer<typeof Platform>;

export const Currency = z.string().regex(/^[A-Z]{3}$/, 'ISO-4217 currency code');

/**
 * Project-role hierarchy used for transition.allowedRole comparisons.
 * Higher index = more privileged.
 */
export const PROJECT_ROLE_RANK: Record<ProjectRole, number> = {
  viewer: 0,
  member: 1,
  manager: 2,
};

export function projectRoleSatisfies(actual: ProjectRole, required: ProjectRole): boolean {
  return PROJECT_ROLE_RANK[actual] >= PROJECT_ROLE_RANK[required];
}
